import { useCallback, useEffect, useRef } from 'react';

/** Prevent a completed old-page mutation from navigating or toasting in a new scope. */
export function useLivePage() {
  const live = useRef(true);
  useEffect(() => {
    live.current = true;
    return () => {
      live.current = false;
    };
  }, []);
  return useCallback(() => live.current, []);
}
